import { Button } from "@/v2/components/ui/button";

export interface EntriesEmptyStateProps {
	totalEntryCount: number;
	dateFilteredCount: number;
	isMultiDate: boolean;
	onResetFilters: () => void;
}

export function EntriesEmptyState({
	totalEntryCount,
	dateFilteredCount,
	isMultiDate,
	onResetFilters,
}: EntriesEmptyStateProps) {
	const filtersAreEmpty = dateFilteredCount > 0;
	let message = "No entries yet. Tap + to add your first entry.";

	if (filtersAreEmpty) {
		message = "No entries match the selected filters.";
	} else if (isMultiDate && totalEntryCount > 0) {
		message = "No entries for this date range.";
	} else if (totalEntryCount > 0) {
		message = "No entries for this date.";
	}

	return (
		<div className="flex flex-col items-center justify-center gap-3 py-20 text-muted-foreground">
			<p className="text-sm">{message}</p>
			{filtersAreEmpty && (
				<Button
					variant="link"
					size="sm"
					onClick={onResetFilters}
					className="h-auto p-0 text-sm"
				>
					Reset filters
				</Button>
			)}
		</div>
	);
}
